import { ReactNode } from 'react'
import { AuthProvider as AuthProviderCore } from '../../hooks/useAuth'

export const AuthProvider = (props: { children: ReactNode }) => {
  return <AuthProviderCore {...props} />
}
